// Mock data for Matrix Print website

export const services = [
  {
    id: 'business-cards',
    slug: 'business-cards',
    icon: 'CreditCard',
    title: {
      sl: 'Digitalni tisk',
      en: 'Digital Printing',
      it: 'Stampa Digitale'
    },
    description: {
      sl: 'Prilagodljivost, cenovna učinkovitost in vrhunska kakovost za vizitke, letake, kataloge, brošure in druge tiskovine.',
      en: 'Flexibility, cost-effectiveness and premium quality for business cards, flyers, catalogs, brochures and other printed materials.',
      it: 'Flessibilità, convenienza e qualità premium per biglietti da visita, volantini, cataloghi, brochure e altri materiali stampati.'
    },
    details: {
      sl: 'Digitalni tisk odlikujejo prilagodljivost, cenovna učinkovitost in vrhunska kakovost, primerljiva z ofsetnim tiskom. Omogoča hitro izvedbo in kratke dobavne roke, zato je idealna rešitev za vizitke, letake, zloženke, kataloge, menuje, nalepke, dopisne liste, brošure, kuverte, vabila, plakate in druge tiskovine.',
      en: 'Digital printing offers flexibility, cost-effectiveness and premium quality comparable to offset printing. It enables fast execution and short delivery times, making it ideal for business cards, flyers, brochures, catalogs, menus, stickers, letterheads, envelopes, invitations, posters and other printed materials.',
      it: 'La stampa digitale offre flessibilità, convenienza e qualità premium paragonabile alla stampa offset. Consente esecuzione rapida e tempi di consegna brevi, ideale per biglietti da visita, volantini, brochure, cataloghi, menu, adesivi, carta intestata, buste, inviti, poster e altri materiali stampati.'
    },
    features: {
      sl: ['Različni formati in materiali', 'Mat, sijaj ali soft-touch obdelava', 'Hitra izdelava', 'Personalizacija'],
      en: ['Various formats and materials', 'Matte, gloss or soft-touch finish', 'Fast production', 'Personalization'],
      it: ['Vari formati e materiali', 'Finitura opaca, lucida o soft-touch', 'Produzione rapida', 'Personalizzazione']
    },
    image: '/assets/business-cards.jpg',
    heroImage: '/assets/digitalni-tisk-hero.jpg',
    gallery: [
      '/assets/kuverte.png',
      '/assets/vizitke-uv.jpg',
      '/assets/zlozenke.png',
      '/assets/personalizacija.png'
    ]
  },
  {
    id: 'dtf-printing',
    slug: 'dtf-printing',
    icon: 'Shirt',
    title: {
      sl: 'DTF tisk',
      en: 'DTF Printing',
      it: 'Stampa DTF'
    },
    description: {
      sl: 'DTF preslikači za profesionalne rezultate - enostaven prenos, žive barve in dolgotrajna obstojnost.',
      en: 'DTF transfers for professional results - easy application, vibrant colors and long-lasting durability.',
      it: 'Trasferimenti DTF per risultati professionali - applicazione facile, colori vivaci e durata nel tempo.'
    },
    details: {
      sl: 'DTF (Direct to Film) tisk je sodobna tehnologija za prenos grafik na tekstil. Odlikujejo ga enostaven prenos s toplotno prešo, izjemno žive barve ter odlična in dolgotrajna obstojnost. Idealen za majice, puloverje, torbe, kape in druge tekstilne izdelke. Primeren za manjše in večje naročila.',
      en: 'DTF (Direct to Film) printing is a modern technology for transferring graphics onto textiles. It features easy heat press application, exceptionally vibrant colors and excellent long-lasting durability. Ideal for t-shirts, hoodies, bags, caps and other textile products. Suitable for small and large orders.',
      it: 'La stampa DTF (Direct to Film) è una tecnologia moderna per trasferire grafiche su tessuti. Si distingue per la facile applicazione con pressa a caldo, colori eccezionalmente vivaci ed eccellente durata nel tempo. Ideale per magliette, felpe, borse, cappelli e altri prodotti tessili. Adatto per ordini piccoli e grandi.'
    },
    features: {
      sl: ['Prenos na različne tekstile', 'Žive in obstojne barve', 'Primerno za majhne in velike naročila', 'Hitra dobava'],
      en: ['Transfer to various textiles', 'Vibrant and durable colors', 'Suitable for small and large orders', 'Fast delivery'],
      it: ['Trasferimento su vari tessuti', 'Colori vivaci e durevoli', 'Adatto per ordini piccoli e grandi', 'Consegna rapida']
    },
    image: '/assets/about-printer.webp',
    heroImage: '/assets/about-printer.webp',
    gallery: [
      '/assets/dtf-juta-torbe.jpg',
      '/assets/dtf-predpasnik.jpg',
      '/assets/dtf-bombazna-torba.jpg',
      '/assets/dtf-majice.jpg'
    ]
  },
  {
    id: 'large-format',
    slug: 'large-format',
    icon: 'Maximize2',
    title: {
      sl: 'Velikoformatni tisk',
      en: 'Large Format Printing',
      it: 'Stampa Grande Formato'
    },
    description: {
      sl: 'Visoka ločljivost in žive barve na papirju, folijah, platnu, bannerjih, PVC, tekstilu in drugih velikih površinah.',
      en: 'High resolution and vibrant colors on paper, foils, canvas, banners, PVC, textiles and other large surfaces.',
      it: 'Alta risoluzione e colori vivaci su carta, fogli, tela, banner, PVC, tessuti e altre grandi superfici.'
    },
    details: {
      sl: 'Napredna tehnologija velikoformatnega tiska omogoča izjemno kakovost na papirju, folijah, platnu, bannerjih, PVC, tekstilu in drugih velikih površinah. Ostrina detajlov, živahne barve in dolgotrajna obstojnost zagotavljajo profesionalen izgled vaših projektov, ne glede na velikost. Popolna rešitev za reklamne in opozorilne table, plakate, cerade in PVC transparente, jumbo plakate, tisk na trde materiale, izložbe,...',
      en: 'Advanced large format printing technology enables exceptional quality on paper, foils, canvas, banners, PVC, textiles and other large surfaces. Sharp details, vibrant colors and long-lasting durability ensure a professional look for your projects, regardless of size. Perfect solution for advertising and warning signs, posters, tarpaulins and PVC banners, jumbo posters, printing on hard materials, displays,...',
      it: 'La tecnologia avanzata di stampa grande formato consente una qualità eccezionale su carta, fogli, tela, banner, PVC, tessuti e altre grandi superfici. Dettagli nitidi, colori vivaci e durata nel tempo garantiscono un aspetto professionale ai vostri progetti, indipendentemente dalle dimensioni. Soluzione perfetta per insegne pubblicitarie e di avvertimento, poster, teloni e banner in PVC, poster jumbo, stampa su materiali duri, espositori,...'
    },
    features: {
      sl: ['Visoka ločljivost in žive barve tudi na velikih formatih', 'Dolgotrajna obstojnost in odpornost na vremenske vplive', 'Tisk na različne materiale – od papirja do PVC, platna in tekstila', 'Primerno za notranje in zunanje uporabo', 'Možnost personalizacije in unikatnih grafičnih rešitev', 'Idealno za majhne serije in velike projekte'],
      en: ['High resolution and vibrant colors even on large formats', 'Long-lasting durability and weather resistance', 'Printing on various materials – from paper to PVC, canvas and textiles', 'Suitable for indoor and outdoor use', 'Customization and unique graphic solutions available', 'Ideal for small runs and large projects'],
      it: ['Alta risoluzione e colori vivaci anche su grandi formati', 'Durata nel tempo e resistenza alle intemperie', 'Stampa su vari materiali – dalla carta al PVC, tela e tessuti', 'Adatto per uso interno ed esterno', 'Personalizzazione e soluzioni grafiche uniche disponibili', 'Ideale per piccole tirature e grandi progetti']
    },
    image: '/assets/veliko1-hero.jpg',
    heroImage: '/assets/veliko1-hero.jpg',
    gallery: [
      '/assets/veliko-hero.jpg',
      '/assets/veliko-ref1.jpg',
      '/assets/veliko-ref2.jpg',
      '/assets/veliko-ref4.jpg',
      '/assets/veliko3-istrabenz.jpg',
      '/assets/veliko4-restaurant.jpg'
    ]
  },
  {
    id: 'uv-printing',
    slug: 'uv-printing',
    icon: 'Sun',
    title: {
      sl: 'UV tisk',
      en: 'UV Printing',
      it: 'Stampa UV'
    },
    description: {
      sl: 'Vrhunska kakovost na skoraj vseh materialih - plastika, kovina, steklo, les, tekstil.',
      en: 'Premium quality on almost all materials - plastic, metal, glass, wood, textiles.',
      it: 'Qualità premium su quasi tutti i materiali - plastica, metallo, vetro, legno, tessuti.'
    },
    details: {
      sl: 'Vrhunska kakovost na skoraj vseh materialih. Napredna UV tehnologija omogoča visokokakovosten in obstojen tisk na plastiko, kovino, steklo, les, tekstil in številne druge površine. Barve se ob izpostavitvi UV svetlobi takoj strdijo, kar zagotavlja ostre detajle, živahne barve in dolgotrajno odpornost. Popolna rešitev za promocijske izdelke, industrijske oznake in unikatne projekte.',
      en: 'Premium quality on almost all materials. Advanced UV technology enables high-quality and durable printing on plastic, metal, glass, wood, textiles and many other surfaces. Colors cure instantly when exposed to UV light, ensuring sharp details, vibrant colors and long-lasting resistance. Perfect solution for promotional products, industrial labels and unique projects.',
      it: 'Qualità premium su quasi tutti i materiali. La tecnologia UV avanzata consente una stampa di alta qualità e durevole su plastica, metallo, vetro, legno, tessuti e molte altre superfici. I colori si asciugano istantaneamente quando esposti alla luce UV, garantendo dettagli nitidi, colori vivaci e resistenza duratura. Soluzione perfetta per prodotti promozionali, etichette industriali e progetti unici.'
    },
    features: {
      sl: ['Dolgotrajna obstojnost', 'Izjemna barvna natančnost in visoka ločljivost', 'Takojšnje sušenje brez dodatne obdelave', 'Tisk v CMYK, belo in z lakom za posebne učinke', 'Primerno tudi za občutljive materiale', 'Idealno za majhne in velike naklade'],
      en: ['Long-lasting durability', 'Exceptional color accuracy and high resolution', 'Instant drying without additional processing', 'CMYK, white and varnish printing for special effects', 'Suitable for sensitive materials', 'Ideal for small and large orders'],
      it: ['Durata nel tempo', 'Eccezionale precisione del colore e alta risoluzione', 'Asciugatura istantanea senza lavorazioni aggiuntive', 'Stampa CMYK, bianco e vernice per effetti speciali', 'Adatto per materiali sensibili', 'Ideale per ordini piccoli e grandi']
    },
    image: '/assets/uv1-hero.jpg',
    heroImage: '/assets/uv1-hero.jpg',
    gallery: [
      '/assets/uv2-ref.jpg',
      '/assets/uv3-ref.jpg',
      '/assets/uv4-ref.jpg',
      '/assets/uv5-ref.jpg'
    ]
  },
  {
    id: 'laser-engraving',
    slug: 'laser-engraving',
    icon: 'Zap',
    title: {
      sl: 'Lasersko graviranje',
      en: 'Laser Engraving',
      it: 'Incisione Laser'
    },
    description: {
      sl: 'Natančno in trajno označevanje na lesu, kovini, steklu, akrilu, usnju in drugih materialih.',
      en: 'Precise and permanent marking on wood, metal, glass, acrylic, leather and other materials.',
      it: 'Marcatura precisa e permanente su legno, metallo, vetro, acrilico, pelle e altri materiali.'
    },
    details: {
      sl: 'Laserska gravura omogoča natančno in trajno označevanje na lesu, kovini, steklu, akrilu, usnju in drugih materialih. Z visoko natančnostjo ustvarja ostre detajle, fine črte in unikatne vzorce, ki trajajo. Popolna rešitev za darila, priznanja, industrijske oznake in ekskluzivne izdelke.',
      en: 'Laser engraving enables precise and permanent marking on wood, metal, glass, acrylic, leather and other materials. With high precision, it creates sharp details, fine lines and unique patterns that last. Perfect solution for gifts, awards, industrial labels and exclusive products.',
      it: 'L\'incisione laser consente una marcatura precisa e permanente su legno, metallo, vetro, acrilico, pelle e altri materiali. Con alta precisione, crea dettagli nitidi, linee fini e motivi unici che durano. Soluzione perfetta per regali, premi, etichette industriali e prodotti esclusivi.'
    },
    features: {
      sl: ['Trajna in odporna na obrabo', 'Izjemna natančnost detajlov', 'Primerno za različne materiale – les, kovino, steklo, akril, usnje', 'Elegantni in profesionalni rezultati', 'Idealno za personalizacijo, promocijske izdelke in unikatne projekte', 'Brez kemičnih postopkov, okolju prijazno'],
      en: ['Durable and wear-resistant', 'Exceptional detail precision', 'Suitable for various materials – wood, metal, glass, acrylic, leather', 'Elegant and professional results', 'Ideal for personalization, promotional products and unique projects', 'No chemical processes, environmentally friendly'],
      it: ['Durevole e resistente all\'usura', 'Eccezionale precisione dei dettagli', 'Adatto a vari materiali – legno, metallo, vetro, acrilico, pelle', 'Risultati eleganti e professionali', 'Ideale per personalizzazione, prodotti promozionali e progetti unici', 'Senza processi chimici, ecologico']
    },
    image: '/assets/laser1-hero.jpg',
    heroImage: '/assets/laser1-hero.jpg',
    gallery: [
      '/assets/laser2-ref.jpg',
      '/assets/laser3-ref.jpg',
      '/assets/laser4-ref.jpg',
      '/assets/laser5-ref.jpg'
    ]
  },
  {
    id: 'stickers-labels',
    slug: 'stickers-labels',
    icon: 'Tag',
    title: {
      sl: 'Nalepke in etikete',
      en: 'Stickers & Labels',
      it: 'Adesivi ed Etichette'
    },
    description: {
      sl: 'Nalepke po meri, etikete za izdelke, notranje/zunanje',
      en: 'Custom stickers, product labels, indoor/outdoor',
      it: 'Adesivi personalizzati, etichette prodotto, interno/esterno'
    },
    details: {
      sl: 'Od etiket za izdelke do promocijskih nalepk - ponujamo različne materiale in oblike za vse potrebe.',
      en: 'From product labels to promotional stickers - we offer various materials and shapes for all needs.',
      it: 'Dalle etichette prodotto agli adesivi promozionali - offriamo vari materiali e forme per tutte le esigenze.'
    },
    features: {
      sl: ['Rezanje po konturo', 'Odporne na vreme', 'Mat ali sijajne', 'Majhne ali velike količine'],
      en: ['Contour cutting', 'Weather resistant', 'Matte or glossy', 'Small or large quantities'],
      it: ['Taglio sagomato', 'Resistenti alle intemperie', 'Opache o lucide', 'Piccole o grandi quantità']
    },
    image: '/assets/zrcalne-folije-2.jpg',
    heroImage: '/assets/zrcalne-folije-2.jpg',
    gallery: [
      '/assets/zrcalne-folije-2.jpg',
      '/assets/zrcalne-folije-1.jpg'
    ]
  },
  {
    id: 'light-signs',
    slug: 'light-signs',
    icon: 'Lightbulb',
    title: {
      sl: 'Svetlobne table in napisi',
      en: 'Light Boxes & Signs',
      it: 'Insegne Luminose e Scritte'
    },
    description: {
      sl: 'Učinkovita in privlačna rešitev za jasno predstavitev vaše blagovne znamke z LED osvetlitvijo.',
      en: 'Effective and attractive solution for clear presentation of your brand with LED lighting.',
      it: 'Soluzione efficace e attraente per una chiara presentazione del vostro marchio con illuminazione LED.'
    },
    details: {
      sl: 'Svetlobne table so učinkovita in privlačna rešitev za jasno predstavitev vaše blagovne znamke. Z enakomerno LED osvetlitvijo zagotavljajo odlično vidnost v vseh pogojih – podnevi, ponoči ali v zaprtih prostorih. Primerne so za poslovne prostore, trgovine, lokale, pisarne in druge objekte.',
      en: 'Light boxes are an effective and attractive solution for clearly presenting your brand. With uniform LED lighting, they ensure excellent visibility in all conditions – day, night or indoors. Suitable for business premises, shops, bars, offices and other buildings.',
      it: 'Le insegne luminose sono una soluzione efficace e attraente per presentare chiaramente il vostro marchio. Con illuminazione LED uniforme, garantiscono un\'eccellente visibilità in tutte le condizioni – giorno, notte o al chiuso. Adatte per locali commerciali, negozi, bar, uffici e altri edifici.'
    },
    features: {
      sl: ['Odlična vidnost 24/7', 'Energetsko varčna LED osvetlitev', 'Dolga življenjska doba in nizki stroški vzdrževanja', 'Različne oblike, dimenzije in načini montaže', 'Primerno za notranje in zunanje uporabo', 'Prilagoditev grafike vaši celostni podobi'],
      en: ['Excellent 24/7 visibility', 'Energy-efficient LED lighting', 'Long lifespan and low maintenance costs', 'Various shapes, sizes and mounting options', 'Suitable for indoor and outdoor use', 'Graphics customization to your brand identity'],
      it: ['Eccellente visibilità 24/7', 'Illuminazione LED a risparmio energetico', 'Lunga durata e bassi costi di manutenzione', 'Varie forme, dimensioni e opzioni di montaggio', 'Adatto per uso interno ed esterno', 'Personalizzazione grafica alla vostra identità aziendale']
    },
    image: '/assets/svet1-hero.jpg',
    heroImage: '/assets/svet1-hero.jpg',
    gallery: [
      '/assets/svet2-ref.jpg',
      '/assets/svet3-ref.jpg',
      '/assets/svet4-ref.jpg',
      '/assets/svet5-ref.jpg'
    ]
  },
  {
    id: 'vehicle-wrapping',
    slug: 'vehicle-wrapping',
    icon: 'Car',
    title: {
      sl: 'Polepitev vozil in plovil',
      en: 'Vehicle & Boat Wrapping',
      it: 'Wrapping Veicoli e Imbarcazioni'
    },
    description: {
      sl: 'Profesionalna celostna ali delna polepitev vozil in plovil z visokokakovostnimi folijami.',
      en: 'Professional full or partial wrapping of vehicles and boats with high-quality films.',
      it: 'Wrapping professionale completo o parziale di veicoli e imbarcazioni con pellicole di alta qualità.'
    },
    details: {
      sl: 'Polepitev vozil in plovil je učinkovit način za promocijo vašega podjetja ali za zaščito originalnega laka. Uporabljamo visokokakovostne folije, ki zagotavljajo odlično obstojnost, živahne barve in enostavno vzdrževanje. Ponujamo celostne polepitve, delne polepitve, reklamne napise in zaščitne folije. Naša ekipa poskrbi za profesionalno namestitev na osebna vozila, kombinirana vozila, tovorna vozila, avtobuse, plovila,...',
      en: 'Vehicle and boat wrapping is an effective way to promote your business or protect the original paintwork. We use high-quality films that ensure excellent durability, vibrant colors and easy maintenance. We offer full wraps, partial wraps, advertising lettering and protective films. Our team provides professional installation on cars, vans, trucks, buses, boats,...',
      it: 'Il wrapping di veicoli e imbarcazioni è un modo efficace per promuovere la vostra attività o proteggere la vernice originale. Utilizziamo pellicole di alta qualità che garantiscono eccellente durata, colori vivaci e facile manutenzione. Offriamo wrapping completo, parziale, scritte pubblicitarie e pellicole protettive. Il nostro team garantisce un\'installazione professionale su auto, furgoni, camion, autobus, barche,...'
    },
    features: {
      sl: ['Celostna ali delna polepitev vozil', 'Polepitev plovil in jaht', 'Visokokakovostne folije z dolgo življenjsko dobo', 'Zaščita originalnega laka', 'Enostavno vzdrževanje in čiščenje', 'Možnost odstranitve brez poškodb'],
      en: ['Full or partial vehicle wrapping', 'Boat and yacht wrapping', 'High-quality films with long lifespan', 'Protection of original paintwork', 'Easy maintenance and cleaning', 'Removable without damage'],
      it: ['Wrapping completo o parziale dei veicoli', 'Wrapping di barche e yacht', 'Pellicole di alta qualità con lunga durata', 'Protezione della vernice originale', 'Facile manutenzione e pulizia', 'Rimovibile senza danni']
    },
    image: '/assets/inspectus-vw-1.jpg',
    heroImage: '/assets/inspectus-vw-1.jpg',
    gallery: [
      '/assets/inspectus-vw-1.jpg',
      '/assets/avto1-simak.jpg',
      '/assets/avto3-ceva.jpg',
      '/assets/veliko2-boat.jpg',
      '/assets/veliko-ref3.jpg'
    ]
  }
];

export const reviews = [
  {
    id: 1,
    name: 'CALEFFI HIDROTERMIKA d.o.o.',
    rating: 5,
    text: {
      sl: 'Pri Matrix printu smo naročili tako tekstil kot tisk na majice za našo ekipo. Izjemno smo zadovoljni s kakovostjo materialov in obstojnostjo tiska. Celoten proces je potekal profesionalno, z upoštevanjem vseh rokov. Zanesljiv partner, ki ga toplo priporočamo!',
      en: 'At Matrix Print, we ordered both textiles and printing on t-shirts for our team. We are extremely satisfied with the quality of materials and print durability. The entire process was professional, respecting all deadlines. A reliable partner we warmly recommend!',
      it: 'Presso Matrix Print abbiamo ordinato sia tessuti che stampa su magliette per il nostro team. Siamo estremamente soddisfatti della qualità dei materiali e della durata della stampa. Un partner affidabile che raccomandiamo caldamente!'
    },
    service: {
      sl: 'Tisk na tekstil',
      en: 'Textile Printing',
      it: 'Stampa su Tessuti'
    }
  },
  {
    id: 2,
    name: 'ENSOL 360 d.o.o. (Katring 360)',
    rating: 5,
    text: {
      sl: 'Za naše kupce smo potrebovali vrhunske darilne škatle. Ekipa Matrix print je presegla pričakovanja – embalaža je strukturno močna in estetsko dovršena. Profesionalci, ki se držijo rokov!',
      en: 'For our customers, we needed premium gift boxes. The Matrix Print team exceeded expectations – the packaging is structurally strong and aesthetically refined. Professionals who meet deadlines!',
      it: 'Per i nostri clienti avevamo bisogno di scatole regalo premium. Il team Matrix Print ha superato le aspettative – l\'imballaggio è strutturalmente robusto ed esteticamente raffinato!'
    },
    service: {
      sl: 'Embalaža',
      en: 'Packaging',
      it: 'Imballaggio'
    }
  },
  {
    id: 3,
    name: 'TOMMAS d.o.o. (Optika Tommas)',
    rating: 5,
    text: {
      sl: 'Pri velikoformatnem tisku za naše poslovalnice ne sklepamo kompromisov. Matrix print nam je zagotovil vrhunsko resolucijo in barvno natančnost. Odzivnost in montaža sta bili na najvišjem nivoju.',
      en: 'For large-format printing for our stores, we don\'t compromise. Matrix Print provided us with excellent resolution and color accuracy. Responsiveness and installation were at the highest level.',
      it: 'Per la stampa grande formato per i nostri negozi non scendiamo a compromessi. Matrix Print ci ha fornito un\'eccellente risoluzione e precisione dei colori.'
    },
    service: {
      sl: 'Velikoformatni tisk',
      en: 'Large Format Printing',
      it: 'Stampa Grande Formato'
    }
  },
  {
    id: 4,
    name: 'MANAL d.o.o.',
    rating: 5,
    text: {
      sl: 'Potrebovali smo specifično dodelavo in tisk na promocijske artikle ter tekstil. Ekipa v Matrix printu se je izkazala s svojo prilagodljivostjo in tehničnim znanjem. Vse je bilo pripravljeno točno ob dogovorjenem času.',
      en: 'We needed specific finishing and printing on promotional items and textiles. The Matrix Print team excelled with their flexibility and technical knowledge. Everything was ready exactly on time.',
      it: 'Avevamo bisogno di finiture specifiche e stampa su articoli promozionali e tessuti. Il team Matrix Print si è distinto per flessibilità e competenza tecnica.'
    },
    service: {
      sl: 'Promocijski artikli',
      en: 'Promotional Items',
      it: 'Articoli Promozionali'
    }
  },
  {
    id: 5,
    name: 'INSPECTUS d.o.o.',
    rating: 5,
    text: {
      sl: 'Naše nalepke morajo biti vzdržljive in natančno izrezane. Matrix print d.o.o. nam je zagotovil vrhunsko kakovost materialov. Hitra izdelava, ki nam je pomagala ujeti tesne roke.',
      en: 'Our labels must be durable and precisely cut. Matrix Print provided us with top-quality materials. Fast production that helped us meet tight deadlines.',
      it: 'Le nostre etichette devono essere durevoli e tagliate con precisione. Matrix Print ci ha fornito materiali di alta qualità. Produzione rapida che ci ha aiutato a rispettare scadenze strette.'
    },
    service: {
      sl: 'Nalepke',
      en: 'Labels',
      it: 'Etichette'
    }
  },
  {
    id: 6,
    name: 'SIMAK KERAMIKA d.o.o.',
    rating: 5,
    text: {
      sl: 'Zunanje reklamne table so ogledalo našega podjetja. Matrix print je poskrbel za vrhunsko vidnost in obstojnost na vremenske vplive. Odličen partnerski odnos!',
      en: 'Outdoor advertising signs are the mirror of our company. Matrix Print ensured excellent visibility and weather resistance. Excellent partnership!',
      it: 'Le insegne pubblicitarie esterne sono lo specchio della nostra azienda. Matrix Print ha garantito un\'eccellente visibilità e resistenza alle intemperie.'
    },
    service: {
      sl: 'Reklamne table',
      en: 'Advertising Signs',
      it: 'Insegne Pubblicitarie'
    }
  },
  {
    id: 7,
    name: 'AZALENTA d.o.o.',
    rating: 5,
    text: {
      sl: 'Pri izdelavi tiskovin nam je pomembna natančnost in hitrost. Matrix print d.o.o. je postal naš stalni partner, saj se vedno lahko zanesemo na njihovo strokovnost in kakovost tiska.',
      en: 'Precision and speed are important to us in print production. Matrix Print has become our permanent partner, as we can always rely on their expertise and print quality.',
      it: 'Precisione e velocità sono importanti per noi nella produzione di stampa. Matrix Print è diventato il nostro partner permanente.'
    },
    service: {
      sl: 'Tiskovine',
      en: 'Print Materials',
      it: 'Materiali Stampati'
    }
  },
  {
    id: 8,
    name: 'FRIENDS PRODUCTION',
    rating: 5,
    text: {
      sl: 'Kot produkcijska hiša zahtevamo brezhibno izvedbo. Z ekipo Matrix print sodelujemo pri različnih projektih in vedno znova nas navdušijo s svojo profesionalnostjo in odnosom do strank.',
      en: 'As a production house, we demand flawless execution. We collaborate with Matrix Print team on various projects and they always impress us with their professionalism and customer relations.',
      it: 'Come casa di produzione richiediamo un\'esecuzione impeccabile. Collaboriamo con il team Matrix Print su vari progetti e ci impressionano sempre con la loro professionalità.'
    },
    service: {
      sl: 'Različni projekti',
      en: 'Various Projects',
      it: 'Vari Progetti'
    }
  },
  {
    id: 9,
    name: 'PLAY CAFFE BAR',
    rating: 5,
    text: {
      sl: 'Naša nova svetlobna tabla ima vrhunski izgled! Ekipa Matrix print je poskrbela, da naš lokal izstopa, montaža pa je bila hitra in profesionalna. Zelo smo zadovoljni s končnim efektom in kvaliteto izdelave.',
      en: 'Our new light box looks amazing! The Matrix Print team made sure our venue stands out, and the installation was fast and professional. We are very satisfied with the final effect and quality.',
      it: 'La nostra nuova insegna luminosa ha un aspetto eccellente! Il team Matrix Print ha fatto in modo che il nostro locale si distingua, e l\'installazione è stata rapida e professionale.'
    },
    service: {
      sl: 'Svetlobne table',
      en: 'Light Boxes',
      it: 'Insegne Luminose'
    }
  }
];

export const portfolioItems = [
  // Digitalni tisk reference
  {
    id: 1,
    category: 'business-cards',
    title: {
      sl: 'Kuverte z logotipom',
      en: 'Branded Envelopes',
      it: 'Buste con Logo'
    },
    description: {
      sl: 'Personalizirane poslovne kuverte s tiskom logotipa',
      en: 'Personalized business envelopes with logo print',
      it: 'Buste aziendali personalizzate con stampa del logo'
    },
    image: '/assets/kuverte.png',
    whiteBg: true
  },
  {
    id: 2,
    category: 'business-cards',
    title: {
      sl: 'Vizitke z UV lakom',
      en: 'Business Cards with UV Varnish',
      it: 'Biglietti da Visita con Vernice UV'
    },
    description: {
      sl: 'Elegantne vizitke s 3D UV spot lakom',
      en: 'Elegant business cards with 3D UV spot varnish',
      it: 'Biglietti da visita eleganti con vernice UV spot 3D'
    },
    image: '/assets/vizitke-uv.jpg'
  },
  {
    id: 3,
    category: 'business-cards',
    title: {
      sl: 'Zloženke',
      en: 'Folded Brochures',
      it: 'Pieghevoli'
    },
    description: {
      sl: 'Profesionalne zloženke za predstavitev storitev',
      en: 'Professional folded brochures for service presentation',
      it: 'Pieghevoli professionali per presentazione servizi'
    },
    image: '/assets/zlozenke.png'
  },
  {
    id: 4,
    category: 'business-cards',
    title: {
      sl: 'Letaki',
      en: 'Flyers',
      it: 'Volantini'
    },
    description: {
      sl: 'Profesionalni letaki za promocijo storitev in izdelkov',
      en: 'Professional flyers for service and product promotion',
      it: 'Volantini professionali per promozione servizi e prodotti'
    },
    image: '/assets/personalizacija.png',
    whiteBg: true
  },
  // DTF tisk reference
  {
    id: 100,
    category: 'dtf-printing',
    title: {
      sl: 'DTF tisk na juta torbe',
      en: 'DTF Printing on Jute Bags',
      it: 'Stampa DTF su Borse di Juta'
    },
    description: {
      sl: 'DTF preslikači za juta EKO torbe',
      en: 'DTF transfers for jute ECO bags',
      it: 'Trasferimenti DTF per borse ECO in juta'
    },
    image: '/assets/dtf-juta-torbe.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-juta-prej.jpg',
      after: '/assets/prej-potem-juta-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 101,
    category: 'dtf-printing',
    title: {
      sl: 'DTF tisk na predpasnike',
      en: 'DTF Printing on Aprons',
      it: 'Stampa DTF su Grembiuli'
    },
    description: {
      sl: 'DTF preslikači za predpasnike',
      en: 'DTF transfers for aprons',
      it: 'Trasferimenti DTF per grembiuli'
    },
    image: '/assets/dtf-predpasnik.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-predpasnik-prej.jpg',
      after: '/assets/prej-potem-predpasnik-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 102,
    category: 'dtf-printing',
    title: {
      sl: 'DTF tisk na bombažne torbe',
      en: 'DTF Printing on Cotton Bags',
      it: 'Stampa DTF su Borse di Cotone'
    },
    description: {
      sl: 'DTF preslikači za bombažne torbe z večbarvnim tiskom',
      en: 'DTF transfers for cotton bags with multicolor printing',
      it: 'Trasferimenti DTF per borse di cotone con stampa multicolore'
    },
    image: '/assets/dtf-bombazna-torba.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-bombazna-prej.jpg',
      after: '/assets/prej-potem-bombazna-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 103,
    category: 'dtf-printing',
    title: {
      sl: 'DTF tisk na majice',
      en: 'DTF Printing on T-shirts',
      it: 'Stampa DTF su Magliette'
    },
    description: {
      sl: 'DTF preslikači za majice',
      en: 'DTF transfers for t-shirts',
      it: 'Trasferimenti DTF per magliette'
    },
    image: '/assets/dtf-majice.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-majice-prej.jpg',
      after: '/assets/prej-potem-majice-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  // UV tisk reference
  {
    id: 5,
    category: 'uv-printing',
    title: {
      sl: 'UV tisk na pisala',
      en: 'UV Printing on Pens',
      it: 'Stampa UV su Penne'
    },
    description: {
      sl: 'Visokokakovosten UV tisk logotipov na pisala',
      en: 'High-quality UV printing of logos on pens',
      it: 'Stampa UV di alta qualità di loghi su penne'
    },
    image: '/assets/uv1-hero.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-uv1-prej.jpg',
      after: '/assets/prej-potem-uv1-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 6,
    category: 'uv-printing',
    title: {
      sl: 'UV tisk na beležke in pisala',
      en: 'UV Printing on Notebooks and Pens',
      it: 'Stampa UV su Quaderni e Penne'
    },
    description: {
      sl: 'Personalizirane beležke in pisala z UV tiskom',
      en: 'Personalized notebooks and pens with UV printing',
      it: 'Quaderni e penne personalizzati con stampa UV'
    },
    image: '/assets/uv2-ref.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-uv2-prej.jpg',
      after: '/assets/prej-potem-uv2-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 7,
    category: 'uv-printing',
    title: {
      sl: 'UV tisk na modra pisala',
      en: 'UV Printing on Blue Pens',
      it: 'Stampa UV su Penne Blu'
    },
    description: {
      sl: 'UV tisk logotipa na promocijska pisala',
      en: 'UV printing of logo on promotional pens',
      it: 'Stampa UV del logo su penne promozionali'
    },
    image: '/assets/uv3-ref.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-uv3-prej.jpg',
      after: '/assets/prej-potem-uv3-potem.jpg',
      aspect: '1 / 1',
      ratio: 1.0
    }
  },
  {
    id: 8,
    category: 'uv-printing',
    title: {
      sl: 'UV tisk na power banke',
      en: 'UV Printing on Power Banks',
      it: 'Stampa UV su Power Bank'
    },
    description: {
      sl: 'Personalizirane power banke z UV tiskom logotipa',
      en: 'Personalized power banks with UV logo printing',
      it: 'Power bank personalizzati con stampa UV del logo'
    },
    image: '/assets/uv4-ref.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-uv4-prej.jpg',
      after: '/assets/prej-potem-uv4-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 9,
    category: 'uv-printing',
    title: {
      sl: 'UV tisk na vžigalnike',
      en: 'UV Printing on Lighters',
      it: 'Stampa UV su Accendini'
    },
    description: {
      sl: 'Promocijski vžigalniki z UV tiskom',
      en: 'Promotional lighters with UV printing',
      it: 'Accendini promozionali con stampa UV'
    },
    image: '/assets/uv5-ref.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-uv5-prej.jpg',
      after: '/assets/prej-potem-uv5-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 32,
    category: 'uv-printing',
    title: {
      sl: 'UV tisk na pisala',
      en: 'UV Printing on Pens',
      it: 'Stampa UV su Penne'
    },
    description: {
      sl: 'Promocijska pisala z natisnjenim logotipom',
      en: 'Promotional pens with printed logo',
      it: 'Penne promozionali con logo stampato'
    },
    image: '/assets/uv-pisala.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-uv-pisala-prej.jpg',
      after: '/assets/prej-potem-uv-pisala-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  // Lasersko graviranje reference
  {
    id: 10,
    category: 'laser-engraving',
    title: {
      sl: 'Gravura več majhnih logotipov na termo skodelice',
      en: 'Engraving Multiple Small Logos on Thermal Mugs',
      it: 'Incisione di Piccoli Loghi su Tazze Termiche'
    },
    description: {
      sl: 'Natančna gravura več logotipov na termo skodelice',
      en: 'Precise engraving of multiple logos on thermal mugs',
      it: 'Incisione precisa di più loghi su tazze termiche'
    },
    image: '/assets/laser2-ref.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-laser2-prej.jpg',
      after: '/assets/prej-potem-laser2-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 11,
    category: 'laser-engraving',
    title: {
      sl: 'Gravura na posebne odpirače',
      en: 'Engraving on Special Bottle Openers',
      it: 'Incisione su Apribottiglie Speciali'
    },
    description: {
      sl: 'Personalizirana gravura na posebne odpirače',
      en: 'Personalized engraving on special bottle openers',
      it: 'Incisione personalizzata su apribottiglie speciali'
    },
    image: '/assets/laser3-ref.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-laser3-prej.jpg',
      after: '/assets/prej-potem-laser3-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 12,
    category: 'laser-engraving',
    title: {
      sl: 'Gravura na keramične skodelice',
      en: 'Engraving on Ceramic Mugs',
      it: 'Incisione su Tazze in Ceramica'
    },
    description: {
      sl: 'Natančna gravura na keramične skodelice',
      en: 'Precise engraving on ceramic mugs',
      it: 'Incisione precisa su tazze in ceramica'
    },
    image: '/assets/laser4-ref.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-laser4-prej.jpg',
      after: '/assets/prej-potem-laser4-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 13,
    category: 'laser-engraving',
    title: {
      sl: 'Gravura na termo skodelice',
      en: 'Engraving on Thermal Mugs',
      it: 'Incisione su Tazze Termiche'
    },
    description: {
      sl: 'Lasersko graviranje na termo skodelice',
      en: 'Laser engraving on thermal mugs',
      it: 'Incisione laser su tazze termiche'
    },
    image: '/assets/laser5-ref.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-laser5-prej.jpg',
      after: '/assets/prej-potem-laser5-potem.jpg'
    }
  },
  // Velikoformatni tisk reference
  {
    id: 14,
    category: 'large-format',
    title: {
      sl: 'Optika izložba',
      en: 'Optician Store Display',
      it: 'Vetrina Ottica'
    },
    description: {
      sl: 'Velikoformatni plakati za optično trgovino',
      en: 'Large format posters for optical store',
      it: 'Poster grande formato per negozio di ottica'
    },
    image: '/assets/veliko1-hero.jpg'
  },
  {
    id: 15,
    category: 'large-format',
    title: {
      sl: 'Steklena vrata z grbom',
      en: 'Glass Door with Coat of Arms',
      it: 'Porta in Vetro con Stemma'
    },
    description: {
      sl: 'Folija za steklena vrata z dekorativnim vzorcem',
      en: 'Glass door film with decorative pattern',
      it: 'Pellicola per porta in vetro con motivo decorativo'
    },
    image: '/assets/veliko-hero.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-vrata-grb-prej.jpg',
      after: '/assets/prej-potem-vrata-grb-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  {
    id: 16,
    category: 'vehicle-wrapping',
    title: {
      sl: 'Celostna polepitev kombija',
      en: 'Full Van Wrap',
      it: 'Wrapping Completo Furgone'
    },
    description: {
      sl: 'Celostna polepitev vozila za športni klub',
      en: 'Full vehicle wrap for sports club',
      it: 'Wrapping completo del veicolo per club sportivo'
    },
    image: '/assets/veliko-ref3.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-welt-prej.jpg',
      after: '/assets/prej-potem-welt-potem.jpg'
    }
  },
  {
    id: 17,
    category: 'large-format',
    title: {
      sl: 'Hotelski vhod',
      en: 'Hotel Entrance',
      it: 'Ingresso Hotel'
    },
    description: {
      sl: 'Signalizacija in označevanje za hotel',
      en: 'Signage and wayfinding for hotel',
      it: 'Segnaletica e indicazioni per hotel'
    },
    image: '/assets/veliko-ref1.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-hotel-prej.jpg',
      after: '/assets/prej-potem-hotel-potem.jpg'
    }
  },
  {
    id: 18,
    category: 'large-format',
    title: {
      sl: 'Zunanja signalizacija',
      en: 'Outdoor Signage',
      it: 'Segnaletica Esterna'
    },
    description: {
      sl: 'Rumena signalizacija za poslovne prostore',
      en: 'Yellow signage for business premises',
      it: 'Segnaletica gialla per locali commerciali'
    },
    image: '/assets/veliko-ref2.jpg'
  },
  {
    id: 19,
    category: 'vehicle-wrapping',
    title: {
      sl: 'Polepitev plovila',
      en: 'Boat Wrap',
      it: 'Wrapping Barca'
    },
    description: {
      sl: 'Polepitev plovila z imenom in registracijo',
      en: 'Boat wrap with name and registration',
      it: 'Wrapping barca con nome e registrazione'
    },
    image: '/assets/veliko2-boat.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-boat-prej.jpg',
      after: '/assets/prej-potem-boat-potem.jpg'
    }
  },
  {
    id: 20,
    category: 'large-format',
    title: {
      sl: 'Pisarniška vrata z logotipom',
      en: 'Office Door with Logo',
      it: 'Porta Ufficio con Logo'
    },
    description: {
      sl: 'Folija za vrata z logotipom podjetja',
      en: 'Door film with company logo',
      it: 'Pellicola per porta con logo aziendale'
    },
    image: '/assets/veliko3-istrabenz.jpg'
  },
  {
    id: 21,
    category: 'large-format',
    title: {
      sl: 'Dekorativna okenska folija',
      en: 'Decorative Window Film',
      it: 'Pellicola Decorativa per Finestre'
    },
    description: {
      sl: 'Vzorčasta folija za okna in steklene površine',
      en: 'Patterned film for windows and glass surfaces',
      it: 'Pellicola con motivi per finestre e superfici in vetro'
    },
    image: '/assets/veliko-ref4.jpg'
  },
  {
    id: 28,
    category: 'vehicle-wrapping',
    title: {
      sl: 'Polepitev vozila',
      en: 'Vehicle Wrapping',
      it: 'Wrapping Veicolo'
    },
    description: {
      sl: 'Celostna polepitev dostavnega vozila',
      en: 'Full delivery vehicle wrapping',
      it: 'Wrapping completo veicolo commerciale'
    },
    image: '/assets/avto1-simak.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-simak-prej.jpg',
      after: '/assets/prej-potem-simak-potem.jpg'
    }
  },
  {
    id: 29,
    category: 'large-format',
    title: {
      sl: 'Fototapeta za notranje prostore',
      en: 'Interior Photo Wallpaper',
      it: 'Fototapeta per Interni'
    },
    description: {
      sl: 'Dekorativna fototapeta za poslovne prostore',
      en: 'Decorative photo wallpaper for business premises',
      it: 'Fototapeta decorativa per locali commerciali'
    },
    image: '/assets/avto2-fototapeta.jpg'
  },
  {
    id: 30,
    category: 'vehicle-wrapping',
    title: {
      sl: 'Polepitev tovornih vozil',
      en: 'Truck Fleet Wrapping',
      it: 'Wrapping Flotta Camion'
    },
    description: {
      sl: 'Celostna polepitev flote tovornih vozil',
      en: 'Full fleet truck wrapping',
      it: 'Wrapping completo flotta camion'
    },
    image: '/assets/avto3-ceva.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-ceva-prej.jpg',
      after: '/assets/prej-potem-ceva-potem.jpg'
    }
  },
  {
    id: 31,
    category: 'vehicle-wrapping',
    title: {
      sl: 'Polepitev električnega vozila',
      en: 'Electric Vehicle Wrapping',
      it: 'Wrapping Veicolo Elettrico'
    },
    description: {
      sl: 'Celostna polepitev električnega vozila VW ID.4',
      en: 'Full wrap of electric vehicle VW ID.4',
      it: 'Wrapping completo veicolo elettrico VW ID.4'
    },
    image: '/assets/inspectus-vw-1.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-vw-prej.jpg',
      after: '/assets/prej-potem-vw-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    },
    gallery: [
      '/assets/inspectus-vw-1.jpg',
      '/assets/inspectus-vw-2.jpg',
      '/assets/inspectus-vw-3.jpg'
    ]
  },
  {
    id: 104,
    category: 'vehicle-wrapping',
    title: {
      sl: 'Polepitev gostinske prikolice',
      en: 'Food Trailer Wrapping',
      it: 'Wrapping Rimorchio Gastronomico'
    },
    description: {
      sl: 'Polepitev gostinske prikolice zunanjost in notranjost',
      en: 'Food trailer wrapping exterior and interior',
      it: 'Wrapping rimorchio gastronomico esterno e interno'
    },
    image: '/assets/prikolica-stran.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-prikolica-prej.jpg',
      after: '/assets/prej-potem-prikolica-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    },
    gallery: [
      '/assets/prikolica-stran.jpg',
      '/assets/prikolica-zadaj.jpg',
      '/assets/prikolica-notranjost.jpg'
    ]
  },
  // Velikoformatni tisk – izložba A.L.A. Group
  {
    id: 107,
    category: 'large-format',
    title: {
      sl: 'Polepitev izložbe A.L.A. Group',
      en: 'A.L.A. Group Shop Window Graphics',
      it: 'Grafica vetrina A.L.A. Group'
    },
    description: {
      sl: 'Celostna polepitev izložbe poslovalnice A.L.A. Group Packaging v Kopru: peskana (frosted) folija z velikim logotipom in kontaktnim pasom, tiskan promocijski plakat za izdelke io čez celotno steklo ter polepitev vhodnih vrat z logotipom, urnikom in podatki podjetja. Zasebnost, prepoznavnost in oglasni prostor v enem.',
      en: 'Complete shop window graphics for the A.L.A. Group Packaging branch in Koper: frosted film with a large logo and contact strip, a full-glass printed promotional poster for io products, and entrance door graphics with logo, opening hours and company details. Privacy, visibility and advertising space in one.',
      it: 'Decorazione completa della vetrina della filiale A.L.A. Group Packaging a Capodistria: pellicola satinata con grande logo e fascia contatti, poster promozionale stampato a tutto vetro per i prodotti io e grafica della porta d\'ingresso con logo, orari e dati aziendali. Privacy, visibilità e spazio pubblicitario in uno.'
    },
    image: '/assets/ala-group-izlozba.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-ala-prej.jpg',
      after: '/assets/prej-potem-ala-potem.jpg'
    }
  },
  // Nalepke in etikete reference
  {
    id: 106,
    category: 'stickers-labels',
    title: {
      sl: 'Montaža zrcalnih folij in nalepk',
      en: 'Mirror Film and Sticker Installation',
      it: 'Montaggio di Pellicole a Specchio e Adesivi'
    },
    description: {
      sl: 'Montaža zrcalnih (reflektivnih) folij na stekleno fasado poslovne stavbe in garažna vrata za zaščito pred soncem in večjo zasebnost ter polepitev stekel s peskanimi pasovi, logotipi in napisi iz rezane folije.',
      en: 'Installation of mirror (reflective) window film on the glass facade of a business building and garage door for sun protection and privacy, combined with frosted strips, logos and lettering made from cut vinyl.',
      it: 'Montaggio di pellicole a specchio (riflettenti) sulla facciata in vetro di un edificio commerciale e sulla porta del garage per protezione solare e privacy, con fasce satinate, loghi e scritte in vinile intagliato.'
    },
    image: '/assets/zrcalne-folije-2.jpg',
    beforeAfter: [
      {
        before: '/assets/prej-potem-zrcalne2-prej.jpg',
        after: '/assets/prej-potem-zrcalne2-potem.jpg'
      },
      {
        before: '/assets/prej-potem-zrcalne1-prej.jpg',
        after: '/assets/prej-potem-zrcalne1-potem.jpg',
        aspect: '1 / 1',
        ratio: 1
      }
    ],
    gallery: [
      '/assets/zrcalne-folije-2.jpg',
      '/assets/zrcalne-folije-1.jpg'
    ]
  },
  // Lasersko graviranje reference
  {
    id: 22,
    category: 'laser-engraving',
    title: {
      sl: 'Gravirane promocijske steklenice',
      en: 'Engraved Promotional Bottles',
      it: 'Bottiglie Promozionali Incise'
    },
    description: {
      sl: 'Lasersko gravirane promocijske steklenice',
      en: 'Laser engraved promotional bottles',
      it: 'Bottiglie promozionali incise al laser'
    },
    image: '/assets/laser1-hero.jpg',
    beforeAfter: {
      before: '/assets/prej-potem-laser1-prej.jpg',
      after: '/assets/prej-potem-laser1-potem.jpg',
      aspect: '2 / 3',
      ratio: 0.667
    }
  },
  // Svetlobne table reference
  {
    id: 105,
    category: 'light-signs',
    title: {
      sl: 'Informativne table',
      en: 'Informational Signs',
      it: 'Insegne Informative'
    },
    description: {
      sl: 'Informativne table iz pleksi stekla z UV tiskom za hotelski savna center – tlorisi, navodila za uporabo savn in informacije v štirih jezikih, montirane na distančnike.',
      en: 'Plexiglass informational signs with UV printing for a hotel sauna center – floor plans, sauna usage instructions and information in four languages, mounted on stand-offs.',
      it: 'Insegne informative in plexiglass con stampa UV per un centro sauna di hotel – planimetrie, istruzioni per l\'uso delle saune e informazioni in quattro lingue, montate su distanziali.'
    },
    image: '/assets/informativne-3.jpg',
    gallery: [
      '/assets/informativne-3.jpg',
      '/assets/informativne-2.jpg',
      '/assets/informativne-4.jpg',
      '/assets/informativne-1.jpg'
    ]
  },
  {
    id: 23,
    category: 'light-signs',
    title: {
      sl: 'Svetlobna tabla za optiko',
      en: 'Light Box for Optical Store',
      it: 'Insegna Luminosa per Ottica'
    },
    description: {
      sl: 'Svetlobna tabla z LED osvetlitvijo za optično trgovino',
      en: 'Light box with LED lighting for optical store',
      it: 'Insegna luminosa con illuminazione LED per negozio di ottica'
    },
    image: '/assets/svet1-hero.jpg'
  },
  {
    id: 24,
    category: 'light-signs',
    title: {
      sl: 'Neonski napis za bar',
      en: 'Neon Sign for Bar',
      it: 'Insegna Neon per Bar'
    },
    description: {
      sl: 'Svetlobni neonski napis za gostinski lokal',
      en: 'Neon light sign for hospitality venue',
      it: 'Insegna luminosa neon per locale'
    },
    image: '/assets/svet2-ref.jpg'
  },
  {
    id: 25,
    category: 'light-signs',
    title: {
      sl: 'Svetlobna tabla z logotipom',
      en: 'Light Box with Logo',
      it: 'Insegna Luminosa con Logo'
    },
    description: {
      sl: 'Svetlobna tabla z logotipom za poslovne prostore',
      en: 'Light box with logo for business premises',
      it: 'Insegna luminosa con logo per locali commerciali'
    },
    image: '/assets/svet3-ref.jpg'
  },
  {
    id: 26,
    category: 'light-signs',
    title: {
      sl: 'Svetlobni napis za kavarno',
      en: 'Light Sign for Cafe',
      it: 'Insegna Luminosa per Caffetteria'
    },
    description: {
      sl: 'Svetlobni napis z LED osvetlitvijo',
      en: 'Light sign with LED lighting',
      it: 'Insegna luminosa con illuminazione LED'
    },
    image: '/assets/svet4-ref.jpg'
  },
  {
    id: 27,
    category: 'light-signs',
    title: {
      sl: 'Svetlobna tabla - nočni pogled',
      en: 'Light Box - Night View',
      it: 'Insegna Luminosa - Vista Notturna'
    },
    description: {
      sl: 'LED svetlobni napis - nočni pogled',
      en: 'LED light sign - night view',
      it: 'Insegna luminosa LED - vista notturna'
    },
    image: '/assets/svet5-ref.jpg'
  }
];

export const whyChooseUs = [
  {
    icon: 'Zap',
    title: {
      sl: 'Hitra izvedba',
      en: 'Fast Turnaround',
      it: 'Consegna Rapida'
    },
    description: {
      sl: 'Večina naročil je pripravljena v 2-3 dneh',
      en: 'Most orders ready in 2-3 days',
      it: 'La maggior parte degli ordini pronti in 2-3 giorni'
    }
  },
  {
    icon: 'Lightbulb',
    title: {
      sl: 'Rešitve po meri',
      en: 'Custom Solutions',
      it: 'Soluzioni Personalizzate'
    },
    description: {
      sl: 'Vsaka ideja je izziv, ki ga radi sprejmemo',
      en: 'Every idea is a challenge we gladly accept',
      it: 'Ogni idea è una sfida che accettiamo volentieri'
    }
  },
  {
    icon: 'HeadphonesIcon',
    title: {
      sl: 'Profesionalno svetovanje',
      en: 'Professional Advice',
      it: 'Consulenza Professionale'
    },
    description: {
      sl: 'Pomagamo izboljšati vaše ideje',
      en: 'We help improve your ideas',
      it: 'Aiutiamo a migliorare le vostre idee'
    }
  },
  {
    icon: 'Star',
    title: {
      sl: 'Visoka ocena strank',
      en: 'High Customer Satisfaction',
      it: 'Alta Soddisfazione del Cliente'
    },
    description: {
      sl: '4.9 / 5 iz 30 ocen',
      en: '4.9 / 5 from 30 reviews',
      it: '4.9 / 5 da 30 recensioni'
    }
  }
];

export const contactInfo = {
  address: {
    sl: 'Ulica 15. maja 10, 6000 Koper, Slovenija',
    en: 'Ulica 15. maja 10, 6000 Koper, Slovenia',
    it: 'Ulica 15. maja 10, 6000 Capodistria, Slovenia'
  },
  phone: '031 365 657',
  email: 'info@matrixprint.si',
  website: 'www.matrixprint.si',
  hours: {
    sl: 'Ponedeljek–Petek, 08:00–16:00',
    en: 'Monday–Friday, 08:00–16:00',
    it: 'Lunedì–Venerdì, 08:00–16:00'
  },
  mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2803.9876543!2d13.7301!3d45.5469!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDXCsDMyJzQ4LjgiTiAxM8KwNDMnNDguNCJF!5e0!3m2!1sen!2ssi!4v1234567890'
};
